import React, { Component } from 'react';
import axios from 'axios';
import AsyncSelect from 'react-select/async';

import formatPhone from '../../../utils/formatPhoneForUser';

import getWebchatUrl from '../../../utils/getWebchatUrl';
import getSearchUrl from '../../../utils/getSearchUrl';
import { connect } from 'react-redux';
const DEFAULT_LABEL = 'enter four letters or numbers...';

class CustomerSearch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchBarValueCustomer: '',
		};
		this.webchatApiUrl = getWebchatUrl(window.location.href);
	}

	handleInputChangeCustomer = (event) => {
		// when we click away the event becomes ''
		// if there is more than 2 characters when we click away keep them there

		// else if we are trying to erase the last character to become ''
		if (
			(event === '' &&
				event.length ===
					this.state.searchBarValueCustomer.length - 1) ||
			event !== ''
		) {
			return this.setState({ searchBarValueCustomer: event });
		}
	};

	handleSelectCustomerChange = async (value, action) => {
		// if user selects Enter more numbers... option, do nothing.
		if (value.value === 'more' || value.label === DEFAULT_LABEL) {
			this.setState({ searchBarValueCustomer: '' });
			return;
		}

		// if user selects a customer, add it to customer data array, and display it.
		if (action.action === 'select-option') {
			this.props.handleSelectCustomer(value.value);
			this.setState({ searchBarValueCustomer: '' });
		}
	};

	contactInfo = (customer) => {
		let contactLabel = '';

		if (customer.phone) {
			contactLabel = formatPhone(customer.phone);
		} else if (customer.email) {
			contactLabel = customer.email;
		} else if (customer.facebookUserId) {
			contactLabel = 'Facebook';
		} else if (customer.googleConversationId) {
			contactLabel = 'Google Business Message';
		}

		return contactLabel;
	};

	getLabel = (customer) => (
		<div>
			<p className="text-sm font-semibold">{customer.name}</p>
			<p className="text-muted-foreground text-xs">
				{this.contactInfo(customer)}
			</p>
		</div>
	);

	searchForCustomer = async (searchTerm) => {
		const safeSearchTerm = searchTerm.replace(/[\W_]+/g, '');

		const isNum = /^\d+$/.test(safeSearchTerm);

		// only ping back end if length is greater than 3
		if (
			(!isNum && safeSearchTerm.length > 3) ||
			(isNum && safeSearchTerm.length > 3)
		) {
			const res = await axios(
				`${getSearchUrl(window.location.href)}/api/customer-search`,
				{
					method: 'post',
					data: {
						searchTerm,
						isEnterpriseRequested:
							this.props.auth.isEnterpriseEnabled,
					},
					withCredentials: true,
				}
			);

			const { matchingCustomers } = res.data;

			if (matchingCustomers) {
				const hasEmailOrPhoneCustomers = matchingCustomers.filter(
					(c) => c.phone || c.email
				);

				const options = hasEmailOrPhoneCustomers.map((customer) => {
					return {
						value: customer,
						label: this.getLabel(customer),
					};
				});

				return options;
			}
		}

		return [{ value: 'more', label: DEFAULT_LABEL }];
	};

	customStyles = () => {
		// If minimal prop is passed, use minimal styles
		if (this.props.minimal) {
			return {
				dropdownIndicator: (cStyles) => ({
					...cStyles,
					display: 'none',
				}),
				indicatorSeparator: (cStyles) => ({
					...cStyles,
					display: 'none',
				}),
				control: (base) => ({
					...base,
					minHeight: '32px',
					height: '32px',
					border: 'none',
					borderRadius: '0',
					boxShadow: 'none',
					backgroundColor: 'transparent',
					'&:hover': {
						cursor: 'text',
					},
				}),
				valueContainer: (base) => ({
					...base,
					padding: '0',
					paddingLeft: '0',
				}),
				input: (base) => ({
					...base,
					margin: '0',
					padding: '0',
				}),
				placeholder: (base) => ({
					...base,
					fontSize: '14px',
					color: 'hsl(var(--muted-foreground))',
				}),
				menuPortal: (base) => ({
					...base,
					zIndex: 999999,
					pointerEvents: 'auto',
				}),
				menu: (base) => ({
					...base,
					zIndex: 999999,
					borderRadius: '6px',
					backgroundColor: 'hsl(var(--popover))',
					border: '1px solid hsl(var(--border))',
					boxShadow:
						'0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
					pointerEvents: 'auto',
				}),
				menuList: (base) => ({
					...base,
					maxHeight: '300px',
					pointerEvents: 'auto',
					overflowY: 'auto',
				}),
				option: (base, state) => ({
					...base,
					padding: '6px 8px',
					fontSize: '14px',
					cursor: 'pointer',
					pointerEvents: 'auto',
					backgroundColor: state.isFocused
						? 'hsl(var(--accent))'
						: state.isSelected
						? 'hsl(var(--primary))'
						: 'hsl(var(--popover))',
					color: state.isSelected
						? 'hsl(var(--primary-foreground))'
						: 'hsl(var(--popover-foreground))',
					'&:hover': {
						backgroundColor: state.isSelected
							? 'hsl(var(--primary))'
							: 'hsl(var(--accent))',
					},
				}),
				noOptionsMessage: (base) => ({
					...base,
					padding: '6px 8px',
					fontSize: '14px',
					color: 'hsl(var(--muted-foreground))',
				}),
				loadingMessage: (base) => ({
					...base,
					padding: '6px 8px',
					fontSize: '14px',
					color: 'hsl(var(--muted-foreground))',
				}),
			};
		}

		// Default styles
		return {
			dropdownIndicator: (cStyles) => ({
				...cStyles,
				display: 'none',
			}),
			indicatorSeparator: (cStyles) => ({
				...cStyles,
				display: 'none',
			}),
			control: (base, state) => ({
				...base,
				backgroundColor: 'hsl(var(--background))',
				borderColor: state.isFocused
					? 'hsl(var(--ring))'
					: 'hsl(var(--input))',
				borderRadius: '6px', // Change border radius
				boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)', // Add subtle shadow
				'&:hover': {
					cursor: 'text',
				},
			}),
			menuPortal: (base) => ({
				...base,
				zIndex: 999999,
				pointerEvents: 'auto',
			}),
			menu: (base) => ({
				...base,
				zIndex: 999999,
				backgroundColor: 'hsl(var(--popover))',
				border: '1px solid hsl(var(--border))',
				pointerEvents: 'auto',
			}),
			menuList: (base) => ({
				...base,
				pointerEvents: 'auto',
				overflowY: 'auto',
				maxHeight: '200px',
			}),
			option: (base, state) => ({
				...base,
				padding: '6px 8px',
				fontSize: '14px',
				cursor: 'pointer',
				pointerEvents: 'auto',
				backgroundColor: state.isFocused
					? 'hsl(var(--accent))'
					: state.isSelected
					? 'hsl(var(--primary))'
					: 'hsl(var(--popover))',
				color: state.isSelected
					? 'hsl(var(--primary-foreground))'
					: 'hsl(var(--popover-foreground))',
				'&:hover': {
					backgroundColor: state.isSelected
						? 'hsl(var(--primary))'
						: 'hsl(var(--accent))',
				},
			}),
		};
	};

	render() {
		// Use minimal classNames if minimal prop is passed
		// Note: Since we're using menuPortalTarget, option styles must be in the styles prop, not classNames
		const classNames = this.props.minimal
			? {
					control: () => 'text-sm',
					placeholder: () => 'text-muted-foreground text-sm',
					input: () => 'text-sm',
					valueContainer: () => '',
					dropdownIndicator: () => 'hidden',
					indicatorSeparator: () => 'hidden',
					clearIndicator: () =>
						'text-muted-foreground hover:text-foreground',
			  }
			: {
					control: (state) =>
						`flex items-center justify-between w-full h-10 rounded-md border border-input bg-background text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
							state.isFocused
								? 'ring-2 ring-offset-2 ring-ring border-ring'
								: 'hover:border-muted-foreground'
						}`,
					placeholder: () => 'text-muted-foreground',
					input: () => 'text-sm text-foreground',
					valueContainer: () => 'py-1.5 px-0.5',
					dropdownIndicator: () => 'hidden',
					indicatorSeparator: () => 'hidden',
					clearIndicator: () =>
						'text-muted-foreground hover:text-foreground',
			  };

		// Only use portal when in minimal mode (inside Sheet)
		const portalProps = this.props.minimal
			? {
					menuPortalTarget: document.body,
					menuPosition: 'fixed',
					menuPlacement: 'auto',
					menuShouldBlockScroll: false,
					closeMenuOnScroll: false,
					captureMenuScroll: false,
					menuShouldScrollIntoView: false,
					blurInputOnSelect: false,
			  }
			: {};

		return (
			<AsyncSelect
				noOptionsMessage={() => 'No clients'}
				placeholder="Search for customer..."
				inputValue={this.state.searchBarValueCustomer}
				value=""
				cacheOptions
				defaultOptions
				loadOptions={this.searchForCustomer}
				styles={this.customStyles()}
				onChange={this.handleSelectCustomerChange}
				onInputChange={this.handleInputChangeCustomer}
				isDisabled={this.props.disabled}
				classNames={classNames}
				{...portalProps}
			/>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth,
	};
}

export default connect(mapStateToProps)(CustomerSearch);
